import classnames from 'classnames';
import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { Feedback } from '../elements/common';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';

interface ISwitchInputProps {
    disabled?: boolean;
    error?: string;
    name?: string;
    onChange: (value: boolean) => void;
    onDoValidate?: () => void;
    value: boolean;
}

export function SwitchInput(props: FormContextProps<ISwitchInputProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => (
                <label
                    className={classnames('switch', { disabled: properties.disabled })}
                    data-dd-privacy="allow"
                >
                    <input
                        checked={properties.value}
                        className="custom-control-input"
                        disabled={properties.disabled}
                        name={properties.name}
                        onChange={async (e) => {
                            await properties.onChange(e.target.checked);
                            if (properties.onDoValidate) {
                                properties.onDoValidate();
                            }
                        }}
                        type="checkbox"
                    />
                    <span className="slider round"></span>
                    <Feedback error={properties.error} />
                </label>
            )}
        </FormContextConsumer>
    );
}

export function SwitchField(props: FormContextProps<ISwitchInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <SwitchInput {...props} />
        </Field>
    );
}
